import React from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../utils/config";

const IntroBulk = ({ onNext, onCancel }) => {
  const { t } = useTranslation("bulkproducts");

  // baseUrl/templates/products.xlsx
  // This is the template file for bulk product uploads
  // Please download and fill in the required fields
  const templateUrl = `${API_URL}/templates/products.xlsx`;
  const exampleUrl = `${API_URL}/templates/products_example.xlsx`;
  // Fetch the template file from the server
  const fetchTemplate = async () => {
    const response = await fetch(templateUrl, {
      credentials: 'include',
      method: 'GET',
    });
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'products.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    if (response.status === 404) {
      console.error("Template not found");
    } else {
      console.error("Error fetching template");
    }
  };


  return (
    <div className="mx-auto p-6">
      <div className="mb-8">
        <h2 className="text-[20px] font-[700] mb-[16px] text-[#464646]">
          {t("intro.title")}
        </h2>
        <p className="text-[20px] font-[500] mb-[8px] text-[#464646]">
          {t("intro.description")}
        </p>
      </div>

      {/* Template Preview Table */}
      <div className="mb-[24px]">
        <div style={{ width: '100%', maxWidth: 1134 }}>
          <svg
            width="100%"
            height="auto"
            viewBox="0 0 1134 192"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block', height: 'auto', maxWidth: '100%' }}
          >
          <g clip-path="url(#clip0_8011_22297)">
            <rect
              x="0.5"
              y="0.5"
              width="1133"
              height="191"
              rx="15.5"
              stroke="#5007C5"
            />
            <mask id="path-4-inside-1_8011_22297" fill="white">
              <path d="M0 16C0 7.16344 7.16344 0 16 0H1118C1126.84 0 1134 7.16344 1134 16V48H0V16Z" />
            </mask>
            <path
              d="M0 16C0 7.16344 7.16344 0 16 0H1118C1126.84 0 1134 7.16344 1134 16V48H0V16Z"
              fill="#FCFCFC"
            />
            <path
              d="M0 0H1134H0ZM1134 49H0V47H1134V49ZM0 48V0V48ZM1134 0V48V0Z"
              fill="#833AF8"
              mask="url(#path-4-inside-1_8011_22297)"
            />
            <path
              d="M27.328 29H25.056V18.328H30.048C32.368 18.328 33.632 19.896 33.632 21.768C33.632 23.624 32.352 25.208 30.048 25.208H27.328V29ZM29.744 23.208C30.64 23.208 31.312 22.648 31.312 21.768C31.312 20.872 30.64 20.328 29.744 20.328H27.328V23.208H29.744ZM42.2564 29H40.2244V24.296C40.2244 23.224 39.6644 22.888 38.7844 22.888C38.0004 22.888 37.3764 23.336 37.0244 23.8V29H34.9924V18.328H37.0244V22.28C37.5204 21.688 38.4804 21.08 39.7444 21.08C41.4404 21.08 42.2564 22.008 42.2564 23.512V29ZM47.8576 29.192C45.3136 29.192 43.7776 27.336 43.7776 25.128C43.7776 22.936 45.3136 21.08 47.8576 21.08C50.4176 21.08 51.9536 22.936 51.9536 25.128C51.9536 27.336 50.4176 29.192 47.8576 29.192ZM47.8576 27.384C49.1216 27.384 49.8416 26.344 49.8416 25.128C49.8416 23.928 49.1216 22.888 47.8576 22.888C46.5936 22.888 45.8896 23.928 45.8896 25.128C45.8896 26.344 46.5936 27.384 47.8576 27.384ZM56.0531 29.192C54.6291 29.192 53.8611 28.456 53.8611 27.08V23.048H52.5811V21.272H53.8611V19.16H55.9091V21.272H57.4771V23.048H55.9091V26.536C55.9091 27.016 56.1651 27.384 56.6131 27.384C56.9171 27.384 57.2051 27.272 57.3171 27.16L57.7491 28.696C57.4451 28.968 56.9011 29.192 56.0531 29.192ZM62.4514 29.192C59.9074 29.192 58.3714 27.336 58.3714 25.128C58.3714 22.936 59.9074 21.08 62.4514 21.08C65.0114 21.08 66.5474 22.936 66.5474 25.128C66.5474 27.336 65.0114 29.192 62.4514 29.192ZM62.4514 27.384C63.7154 27.384 64.4354 26.344 64.4354 25.128C64.4354 23.928 63.7154 22.888 62.4514 22.888C61.1874 22.888 60.4834 23.928 60.4834 25.128C60.4834 26.344 61.1874 27.384 62.4514 27.384Z"
              fill="#2D2D2D"
            />
            <path
              d="M210.995 29H208.723V18.328H213.715C216.035 18.328 217.299 19.896 217.299 21.768C217.299 23.624 216.019 25.208 213.715 25.208H210.995V29ZM213.411 23.208C214.307 23.208 214.979 22.648 214.979 21.768C214.979 20.872 214.307 20.328 213.411 20.328H210.995V23.208H213.411ZM220.691 29H218.659V21.272H220.691V22.328C221.235 21.64 222.195 21.08 223.155 21.08V23.064C223.011 23.032 222.819 23.016 222.595 23.016C221.923 23.016 221.027 23.4 220.691 23.896V29ZM228.009 29.192C225.465 29.192 223.929 27.336 223.929 25.128C223.929 22.936 225.465 21.08 228.009 21.08C230.569 21.08 232.105 22.936 232.105 25.128C232.105 27.336 230.569 29.192 228.009 29.192ZM228.009 27.384C229.273 27.384 229.993 26.344 229.993 25.128C229.993 23.928 229.273 22.888 228.009 22.888C226.745 22.888 226.041 23.928 226.041 25.128C226.041 26.344 226.745 27.384 228.009 27.384ZM240.972 29H238.924V28.008C238.316 28.776 237.468 29.192 236.54 29.192C234.588 29.192 233.116 27.72 233.116 25.144C233.116 22.616 234.572 21.08 236.54 21.08C237.452 21.08 238.316 21.48 238.924 22.264V18.328H240.972V29ZM237.164 27.384C237.852 27.384 238.588 27.016 238.924 26.504V23.768C238.588 23.256 237.852 22.888 237.164 22.888C236.012 22.888 235.212 23.8 235.212 25.144C235.212 26.472 236.012 27.384 237.164 27.384ZM250.235 29H248.203V28.024C247.675 28.616 246.747 29.192 245.483 29.192C243.787 29.192 242.987 28.264 242.987 26.76V21.272H245.019V25.96C245.019 27.032 245.579 27.384 246.443 27.384C247.227 27.384 247.851 26.952 248.203 26.504V21.272H250.235V29ZM255.853 29.192C253.469 29.192 251.757 27.512 251.757 25.128C251.757 22.76 253.469 21.08 255.853 21.08C257.437 21.08 258.397 21.768 258.909 22.472L257.581 23.72C257.213 23.176 256.653 22.888 255.949 22.888C254.717 22.888 253.853 23.784 253.853 25.128C253.853 26.472 254.717 27.384 255.949 27.384C256.653 27.384 257.213 27.064 257.581 26.552L258.909 27.784C258.397 28.504 257.437 29.192 255.853 29.192ZM262.829 29.192C261.405 29.192 260.637 28.456 260.637 27.08V23.048H259.357V21.272H260.637V19.16H262.685V21.272H264.253V23.048H262.685V26.536C262.685 27.016 262.941 27.384 263.389 27.384C263.693 27.384 263.981 27.272 264.093 27.16L264.525 28.696C264.221 28.968 263.677 29.192 262.829 29.192ZM276.985 29H274.953V24.328C274.953 23.256 274.393 22.888 273.529 22.888C272.729 22.888 272.105 23.336 271.769 23.8V29H269.737V21.272H271.769V22.28C272.265 21.688 273.209 21.08 274.473 21.08C276.169 21.08 276.985 22.04 276.985 23.544V29ZM285.675 29H283.643V28.2C283.115 28.824 282.203 29.192 281.195 29.192C279.963 29.192 278.507 28.36 278.507 26.632C278.507 24.824 279.963 24.136 281.195 24.136C282.219 24.136 283.131 24.472 283.643 25.08V24.04C283.643 23.256 282.971 22.744 281.947 22.744C281.115 22.744 280.347 23.048 279.691 23.656L278.923 22.296C279.867 21.464 281.083 21.08 282.299 21.08C284.059 21.08 285.675 21.784 285.675 24.008V29ZM282.011 27.816C282.667 27.816 283.307 27.592 283.643 27.144V26.184C283.307 25.736 282.667 25.512 282.011 25.512C281.211 25.512 280.555 25.928 280.555 26.68C280.555 27.4 281.211 27.816 282.011 27.816ZM299.323 29H297.275V24.12C297.275 23.4 296.955 22.888 296.123 22.888C295.403 22.888 294.811 23.368 294.523 23.784V29H292.475V24.12C292.475 23.4 292.155 22.888 291.323 22.888C290.619 22.888 290.027 23.368 289.723 23.8V29H287.691V21.272H289.723V22.28C290.043 21.816 291.067 21.08 292.251 21.08C293.387 21.08 294.107 21.608 294.395 22.488C294.843 21.784 295.867 21.08 297.051 21.08C298.475 21.08 299.323 21.832 299.323 23.416V29ZM304.948 29.192C302.596 29.192 300.82 27.608 300.82 25.128C300.82 22.888 302.468 21.08 304.82 21.08C307.124 21.08 308.692 22.808 308.692 25.336V25.784H302.948C303.076 26.76 303.86 27.576 305.172 27.576C305.828 27.576 306.74 27.288 307.236 26.808L308.132 28.12C307.364 28.824 306.148 29.192 304.948 29.192ZM306.724 24.408C306.676 23.672 306.164 22.696 304.82 22.696C303.556 22.696 303.012 23.64 302.916 24.408H306.724Z"
              fill="#2D2D2D"
            />
            <path
              d="M396.181 29.192C394.133 29.192 392.661 28.504 391.669 27.496L392.901 25.768C393.653 26.552 394.821 27.208 396.293 27.208C397.541 27.208 398.149 26.632 398.149 26.024C398.149 24.136 392.005 25.432 392.005 21.416C392.005 19.64 393.541 18.168 396.053 18.168C397.749 18.168 399.157 18.68 400.213 19.656L398.949 21.32C398.085 20.52 396.933 20.152 395.845 20.152C394.869 20.152 394.325 20.584 394.325 21.224C394.325 22.92 400.453 21.784 400.453 25.768C400.453 27.72 399.061 29.192 396.181 29.192ZM409.183 29H407.151V28.024C406.623 28.616 405.695 29.192 404.431 29.192C402.735 29.192 401.935 28.264 401.935 26.76V21.272H403.967V25.96C403.967 27.032 404.527 27.384 405.391 27.384C406.175 27.384 406.799 26.952 407.151 26.504V21.272H409.183V29ZM415.616 29.192C414.704 29.192 413.856 28.808 413.232 28.008V31.944H411.2V21.272H413.232V22.248C413.824 21.496 414.672 21.08 415.616 21.08C417.6 21.08 419.04 22.552 419.04 25.128C419.04 27.704 417.6 29.192 415.616 29.192ZM414.976 27.384C416.144 27.384 416.928 26.472 416.928 25.128C416.928 23.8 416.144 22.888 414.976 22.888C414.32 22.888 413.568 23.272 413.232 23.768V26.504C413.568 26.984 414.32 27.384 414.976 27.384ZM424.945 29.192C424.033 29.192 423.185 28.808 422.561 28.008V31.944H420.529V21.272H422.561V22.248C423.153 21.496 424.001 21.08 424.945 21.08C426.929 21.08 428.369 22.552 428.369 25.128C428.369 27.704 426.929 29.192 424.945 29.192ZM424.305 27.384C425.473 27.384 426.257 26.472 426.257 25.128C426.257 23.8 425.473 22.888 424.305 22.888C423.649 22.888 422.897 23.272 422.561 23.768V26.504C422.897 26.984 423.649 27.384 424.305 27.384ZM431.889 29H429.857V18.328H431.889V29ZM434.912 20.44C434.256 20.44 433.696 19.896 433.696 19.224C433.696 18.552 434.256 18.024 434.912 18.024C435.584 18.024 436.128 18.552 436.128 19.224C436.128 19.896 435.584 20.44 434.912 20.44ZM435.936 29H433.904V21.272H435.936V29ZM441.582 29.192C439.23 29.192 437.454 27.608 437.454 25.128C437.454 22.888 439.102 21.08 441.454 21.08C443.758 21.08 445.326 22.808 445.326 25.336V25.784H439.582C439.71 26.76 440.494 27.576 441.806 27.576C442.462 27.576 443.374 27.288 443.87 26.808L444.766 28.12C443.998 28.824 442.782 29.192 441.582 29.192ZM443.358 24.408C443.31 23.672 442.798 22.696 441.454 22.696C440.19 22.696 439.646 23.64 439.55 24.408H443.358ZM448.826 29H446.794V21.272H448.826V22.328C449.37 21.64 450.33 21.08 451.29 21.08V23.064C451.146 23.032 450.954 23.016 450.73 23.016C450.058 23.016 449.162 23.4 448.826 23.896V29Z"
              fill="#2D2D2D"
            />
            <path
              d="M580.808 29H578.52V20.328H575.4V18.328H583.912V20.328H580.808V29ZM584.595 32.024L584.899 30.2C585.075 30.28 585.347 30.328 585.539 30.328C586.067 30.328 586.419 30.184 586.611 29.768L586.899 29.112L583.763 21.272H585.939L587.955 26.648L589.971 21.272H592.163L588.531 30.264C587.955 31.72 586.931 32.104 585.603 32.136C585.363 32.136 584.851 32.088 584.595 32.024ZM597.487 29.192C596.575 29.192 595.727 28.808 595.103 28.008V31.944H593.071V21.272H595.103V22.248C595.695 21.496 596.543 21.08 597.487 21.08C599.471 21.08 600.911 22.552 600.911 25.128C600.911 27.704 599.471 29.192 597.487 29.192ZM596.847 27.384C598.015 27.384 598.799 26.472 598.799 25.128C598.799 23.8 598.015 22.888 596.847 22.888C596.191 22.888 595.439 23.272 595.103 23.768V26.504C595.439 26.984 596.191 27.384 596.847 27.384ZM606.031 29.192C603.679 29.192 601.903 27.608 601.903 25.128C601.903 22.888 603.551 21.08 605.903 21.08C608.207 21.08 609.775 22.808 609.775 25.336V25.784H604.031C604.159 26.76 604.943 27.576 606.255 27.576C606.911 27.576 607.823 27.288 608.319 26.808L609.215 28.12C608.447 28.824 607.231 29.192 606.031 29.192ZM607.807 24.408C607.759 23.672 607.247 22.696 605.903 22.696C604.639 22.696 604.095 23.64 603.999 24.408H607.807Z"
              fill="#2D2D2D"
            />
            <path
              d="M761.995 29H759.723V18.328H764.715C767.035 18.328 768.299 19.896 768.299 21.768C768.299 23.624 767.019 25.208 764.715 25.208H761.995V29ZM764.411 23.208C765.307 23.208 765.979 22.648 765.979 21.768C765.979 20.872 765.307 20.328 764.411 20.328H761.995V23.208H764.411ZM771.691 29H769.659V21.272H771.691V22.328C772.235 21.64 773.195 21.08 774.155 21.08V23.064C774.011 23.032 773.819 23.016 773.595 23.016C772.923 23.016 772.027 23.4 771.691 23.896V29ZM776.433 20.44C775.777 20.44 775.217 19.896 775.217 19.224C775.217 18.552 775.777 18.024 776.433 18.024C777.105 18.024 777.649 18.552 777.649 19.224C777.649 19.896 777.105 20.44 776.433 20.44ZM777.457 29H775.425V21.272H777.457V29ZM783.072 29.192C780.688 29.192 778.976 27.512 778.976 25.128C778.976 22.76 780.688 21.08 783.072 21.08C784.656 21.08 785.616 21.768 786.128 22.472L784.8 23.72C784.432 23.176 783.872 22.888 783.168 22.888C781.936 22.888 781.072 23.784 781.072 25.128C781.072 26.472 781.936 27.384 783.168 27.384C783.872 27.384 784.432 27.064 784.8 26.552L786.128 27.784C785.616 28.504 784.656 29.192 783.072 29.192ZM791.088 29.192C788.736 29.192 786.96 27.608 786.96 25.128C786.96 22.888 788.608 21.08 790.96 21.08C793.264 21.08 794.832 22.808 794.832 25.336V25.784H789.088C789.216 26.76 790 27.576 791.312 27.576C791.968 27.576 792.88 27.288 793.376 26.808L794.272 28.12C793.504 28.824 792.288 29.192 791.088 29.192ZM792.864 24.408C792.816 23.672 792.304 22.696 790.96 22.696C789.696 22.696 789.152 23.64 789.056 24.408H792.864Z"
              fill="#2D2D2D"
            />
            <path
              d="M947.181 29.192C945.133 29.192 943.661 28.504 942.669 27.496L943.901 25.768C944.653 26.552 945.821 27.208 947.293 27.208C948.541 27.208 949.149 26.632 949.149 26.024C949.149 24.136 943.005 25.432 943.005 21.416C943.005 19.64 944.541 18.168 947.053 18.168C948.749 18.168 950.157 18.68 951.213 19.656L949.949 21.32C949.085 20.52 947.933 20.152 946.845 20.152C945.869 20.152 945.325 20.584 945.325 21.224C945.325 22.92 951.453 21.784 951.453 25.768C951.453 27.72 950.061 29.192 947.181 29.192ZM955.308 29.192C953.884 29.192 953.116 28.456 953.116 27.08V23.048H951.836V21.272H953.116V19.16H955.164V21.272H956.732V23.048H955.164V26.536C955.164 27.016 955.42 27.384 955.868 27.384C956.172 27.384 956.46 27.272 956.572 27.16L957.004 28.696C956.7 28.968 956.156 29.192 955.308 29.192ZM964.794 29H962.762V28.2C962.234 28.824 961.322 29.192 960.314 29.192C959.082 29.192 957.626 28.36 957.626 26.632C957.626 24.824 959.082 24.136 960.314 24.136C961.338 24.136 962.25 24.472 962.762 25.08V24.04C962.762 23.256 962.09 22.744 961.066 22.744C960.234 22.744 959.466 23.048 958.81 23.656L958.042 22.296C958.986 21.464 960.202 21.08 961.418 21.08C963.178 21.08 964.794 21.784 964.794 24.008V29ZM961.13 27.816C961.786 27.816 962.426 27.592 962.762 27.144V26.184C962.426 25.736 961.786 25.512 961.13 25.512C960.33 25.512 959.674 25.928 959.674 26.68C959.674 27.4 960.33 27.816 961.13 27.816ZM969.402 29.192C967.978 29.192 967.21 28.456 967.21 27.08V23.048H965.93V21.272H967.21V19.16H969.258V21.272H970.826V23.048H969.258V26.536C969.258 27.016 969.514 27.384 969.962 27.384C970.266 27.384 970.554 27.272 970.666 27.16L971.098 28.696C970.794 28.968 970.25 29.192 969.402 29.192ZM979.464 29H977.432V28.024C976.904 28.616 975.976 29.192 974.712 29.192C973.016 29.192 972.216 28.264 972.216 26.76V21.272H974.248V25.96C974.248 27.032 974.808 27.384 975.672 27.384C976.456 27.384 977.08 26.952 977.432 26.504V21.272H979.464V29ZM984.266 29.192C982.922 29.192 981.626 28.744 980.81 27.992L981.69 26.568C982.25 27.096 983.402 27.624 984.362 27.624C985.242 27.624 985.658 27.272 985.658 26.792C985.658 25.512 981.066 26.552 981.066 23.512C981.066 22.216 982.202 21.08 984.234 21.08C985.546 21.08 986.586 21.528 987.354 22.136L986.538 23.528C986.074 23.032 985.194 22.632 984.25 22.632C983.514 22.632 983.034 22.968 983.034 23.4C983.034 24.552 987.61 23.592 987.61 26.712C987.61 28.12 986.41 29.192 984.266 29.192Z"
              fill="#2D2D2D"
            />
            <mask id="path-12-inside-2_8011_22297" fill="white">
              <path d="M0 48H1190V96H0V48Z" />
            </mask>
            <path d="M0 48H1190V96H0V48Z" fill="#FCFCFC" />
            <path
              d="M1190 96V97H1191V96H1190ZM0 96H-1V97H0V96ZM1190 48H1189V96H1190H1191V48H1190ZM1190 96V95H0V96V97H1190V96ZM0 96H1V48H0H-1V96H0Z"
              fill="#B2B2B2"
              mask="url(#path-12-inside-2_8011_22297)"
            />
            <g clip-path="url(#clip1_8011_22297)">
              <mask id="path-14-inside-3_8011_22297" fill="white">
                <path d="M0 96H1190V144H0V96Z" />
              </mask>
              <path d="M0 96H1190V144H0V96Z" fill="#FCFCFC" />
              <rect
                x="24"
                y="114"
                width="100"
                height="12"
                rx="6"
                fill="#E9E9E9"
              />
              <rect
                x="208"
                y="113"
                width="154"
                height="12"
                rx="6"
                fill="#E9E9E9"
              />
              <rect
                x="391"
                y="113"
                width="150"
                height="12"
                rx="6"
                fill="#E9E9E9"
              />
              <rect
                x="760"
                y="114"
                width="119"
                height="12"
                rx="6"
                fill="#E9E9E9"
              />
              <rect
                x="575"
                y="113"
                width="146"
                height="12"
                rx="6"
                fill="#E9E9E9"
              />
              <rect
                x="942"
                y="114"
                width="114"
                height="12"
                rx="6"
                fill="#E9E9E9"
              />
            </g>
            <path
              d="M1190 144V145H1191V144H1190ZM0 144H-1V145H0V144ZM1190 96H1189V144H1190H1191V96H1190ZM1190 144V143H0V144V145H1190V144ZM0 144H1V96H0H-1V144H0Z"
              fill="#B2B2B2"
              mask="url(#path-14-inside-3_8011_22297)"
            />
            <mask id="path-22-inside-4_8011_22297" fill="white">
              <path d="M0 144H1190V192H0V144Z" />
            </mask>
            <path d="M0 144H1190V192H0V144Z" fill="#FCFCFC" />
            <path
              d="M1190 192V193H1191V192H1190ZM0 192H-1V193H0V192ZM1190 144H1189V192H1190H1191V144H1190ZM1190 192V191H0V192V193H1190V192ZM0 192H1V144H0H-1V192H0Z"
              fill="#B2B2B2"
              mask="url(#path-22-inside-4_8011_22297)"
            />
            <rect
              x="24"
              y="161"
              width="100"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="208"
              y="160"
              width="149"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="391"
              y="160"
              width="150"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="760"
              y="161"
              width="119"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="575"
              y="160"
              width="146"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="942"
              y="161"
              width="114"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect x="23" y="66" width="100" height="12" rx="6" fill="#E9E9E9" />
            <rect
              x="208"
              y="60"
              width="154"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="391"
              y="66"
              width="150"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="759"
              y="66"
              width="119"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="574"
              y="65"
              width="146"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
            <rect
              x="941"
              y="66"
              width="119"
              height="12"
              rx="6"
              fill="#E9E9E9"
            />
          </g>
          <rect
            x="0.5"
            y="0.5"
            width="1133"
            height="191"
            rx="15.5"
            stroke="#833AF8"
          />
          <defs>
            <clipPath id="clip0_8011_22297">
              <rect width="1134" height="192" rx="16" fill="white" />
            </clipPath>
            <clipPath id="clip1_8011_22297">
              <path d="M0 96H1190V144H0V96Z" fill="white" />
            </clipPath>
          </defs>
            </svg>
          </div>
        </div>

      {/* Template Download Section */}

      <div className="mb-[12px]">
        <h3 className="text-[20px] font-[500] text-[#464646] mb-[12px]">
          {t("intro.needTemplate")}
        </h3>
        <p className="text-[16px] font-[500]">
          {t("intro.youCan")}[
          <button
            className="text-[#6609F8] hover:text-purple-700"
            onClick={fetchTemplate}
            type="button"
          >
            {t("intro.downloadTemplate")}
          </button>
          ] {t("intro.or")} [
          <button
            className="text-[#6609F8] hover:text-purple-700"
            onClick={() => window.open(exampleUrl, '_blank')}
            type="button"
          >
            {t("intro.previewTemplate")}
          </button>
          ]
          .
        </p>
      </div>

      <div className="mb-6">
        <h3 className="text-[20px] font-[500] text-[#464646] mb-[8px]">
          {t("intro.allSet")}
        </h3>
        <p className="text-[16px] font-[400] text-[#464646]">
          {t("intro.allSetDescription")}
        </p>
      </div>

      

      {/* Action Buttons */}
      <div className="flex justify-end gap-3">
        <button
          onClick={onCancel}
          className="w-[163px] h-[43px] leading-[1] px-[8px] py-[12px] border border-[#292929] text-[#292929] font-[400] text-[16px] rounded-[8px] hover:bg-gray-50 transition-colors"
        >
          {t("intro.cancel")}
        </button>
        <button
          onClick={onNext}
          className="w-[260px] h-[43px] leading-[1] px-[8px] py-[12px] bg-[#6609F8] text-[#F4F1FF] rounded-[8px] hover:bg-[#5b08e0] transition-colors"
        >
          {t("intro.next")}
        </button>
      </div>
    </div>
  );
};

export default IntroBulk;
